module.exports = __webpack_public_path__ + "static/media/electronicsCard.1655a6df.png";